import Cookies from 'js-cookie';

// Token management
export const setAuthToken = (token: string) => {
    localStorage.setItem('authToken', token);
};

export const getAuthToken = (): string | null => {
    return localStorage.getItem('authToken');
};

export const removeAuthToken = () => {
    localStorage.removeItem('authToken');
};

// Cookie management
export const setAuthCookie = (token: string) => {
    // Set cookie to expire in 7 days
    Cookies.set('authToken', token, { expires: 7 });
};

export const getAuthCookie = (): string | undefined => {
    return Cookies.get('authToken');
};

export const removeAuthCookie = () => {
    Cookies.remove('authToken');
};

// Combined auth management
export const setAuth = (token: string) => {
    setAuthToken(token);
    setAuthCookie(token);
};

export const getAuth = (): string | null => {
    return getAuthToken() || getAuthCookie() || null;
};

export const removeAuth = () => {
    removeAuthToken();
    removeAuthCookie();
};

// Check if user is authenticated
export const isAuthenticated = (): boolean => {
    return !!getAuth();
}; 